$(document).ready(function() {
  var trackMixpanel = function(key, value) {
    if (!params.isLive) {
      return false;
    }

    mixpanel.track(key, value);
  }

  var respondentId = '';
  if (params.isLive) {
    tagUser("https://tag.userreport.com/server.html", {}, function(err, data, tag) {
      if (!err && data.uid) {
        mixpanel.register({ "uid": data.uid });
        respondentId = data.uid;
      }
    });
  }

  // Transition end function from David Walsh: http://davidwalsh.name/css-animation-callback
  function whichTransitionEvent(){
    var t,
        el = document.createElement("fakeelement");

    var transitions = {
      "transition"      : "transitionend",
      "OTransition"     : "oTransitionEnd",
      "MozTransition"   : "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
    };

    for (t in transitions){
      if (el.style[t] !== undefined){
        return transitions[t];
      }
    }
  }

  var transitionEvent = whichTransitionEvent();

  /////////////////////
  // SELECT ELEMENTS //
  /////////////////////

  $('select').bind({
    focus: function(){
      $(this).parent().addClass('select--has-focus');
    },
    blur: function(){
      $(this).parent().removeClass('select--has-focus');
    },
    keyup: function(e) {
      if (e.which === 13) {
        $(this).closest('.js-question').find('.button').triggerClick();
      }
    }
  });

  ///////////////////////////
  // QUESTION SWITCH STUFF //
  ///////////////////////////

  // Set variables
  var $container = $('.js-questions');

  // Move container to first question
  var moveContainer = function(questionNumber) {
    var questionLength = $('.js-question').length;

    // Convert question number to vh unit
    var translateY = (-questionLength + questionNumber) * 100 + 'vh';

    // Store question in variable
    var $question = $('.js-question[data-number=' + questionNumber + '][data-answered="0"][data-visibility="is-visible"]');

    $container.css({
    	'-webkit-transform': 'translateY(' + translateY + ')',
    	'-moz-transform': 'translateY(' + translateY + ')',
    	'-ms-transform': 'translateY(' + translateY + ')',
    	'transform': 'translateY(' + translateY + ')'
    });

    // Focus input if any (when queston transition has ended)
    $question.has('.input-text, select').one(transitionEvent, function(){
      $(this).find('.input-text, select').click().focus();
    });

    if (questionNumber === questionLength) {

      var answers = { answers: $('[data-answered="1"][data-ident]').map(function() {
        var data = $(this).data();
        return {
          "q": Number(data.ident),
          "a": data.result === -1 ? null : data.result,
          "s": data.result === -1,
          "t": data.type
        }
      }).get() };

      answers.answers.push({"q": 22, "a": null, "s": true, "t": 3});
      if (window.qs.demo) {
       console.log('demo mode. answers', answers);
       return;
      }
      var country = answers.answers.find(function(item) { return item.q === 100102; });

      var UA = UAParser();

      var headersIndex = {
        Type: 'SaveResults',
        BuildDate: '12.09.2019 15-38',
        Browser: navigator.userAgent,
        OS: UA.os.name,
        BrowserName: UA.browser.name,
        DeviceType: UA.device.type || 'desktop',
        CountryId: country && country.a,
        WebsiteId: mediaSettings.id,
        InvitationId: uuid(),
        RespondentId: respondentId,
      };
      var head = Object.keys(headersIndex).map(function(key) {
        return key + ': ' + headersIndex[key];
      }).join('\r\n');

      var respondentinfo = { respondentinfo: { std: {}, site: {} } };

      var messageBody = btoa([head, JSON.stringify(answers), JSON.stringify(respondentinfo)].join('\r\n\r\n'));

      trackMixpanel('Survey completed', { messageBody: messageBody })

      var bodyIndex = {
        Action: 'SendMessage',
        QueueUrl: API.URL_QUEUE_VS,
        Version: '2012-11-05',
        MessageBody: messageBody,
      };
      var body = Object.keys(bodyIndex).map(function(key) {
        return key + '=' + encodeURIComponent(bodyIndex[key]);
      }).join('&');

      fetch(API.URL_QUEUE_ORIGIN, {
        mode: 'cors',
        method: 'POST',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        },
        body: body,
        credentials: 'omit',
      });
    }
  };

  // Avoid having the container scroll all the way to bottom on pageload
  setTimeout(function(){
    $container.addClass('questions--animation-active');
  }, 500);

  // Move the container to the intro
  moveContainer(1);

  var trackAnswer = function(node) {
    var $q = $(node).closest('.js-question');
    var questionNumber = $q.attr('data-number');
    // var question = questionsList[questionNumber - 2] || {};
    var answer = $q.attr('data-result');

    if (questionNumber == "1") {
      trackMixpanel('First question answered', { 'answer': answer })
    } else {
      trackMixpanel('Nth question answered', { questionNumber: questionNumber, 'answer': answer })
    }
  };

  // Function for determining which question to scroll to
  var affectingFlow = {};
  var switchQuestion = function(direction, delay) {
    // Get current question and number
    var $currentQuestion = $('.js-question[data-visibility="is-visible"]');
    var answer = $currentQuestion.attr('data-result');
    var current = questionsList[parseInt($currentQuestion.attr('data-number'), 10) - 2];

    if (current) {
      affectingFlow[current.ident] = answer;
    }

    // Get next or prev question depending on direction
    var $nextQuestion;

    // If next
    if (direction === 'next') {

      var repeat;
      var $possibleNextQuestion = $currentQuestion;
      do {
        repeat = false;
        $possibleNextQuestion = $possibleNextQuestion.prev();

        var next = questionsList[parseInt($possibleNextQuestion.attr('data-number'), 10) - 2];
        var affectingFilter = next && next.affectingFilter;
        var affectingAnswer = affectingFilter && affectingFlow[affectingFilter.questionIdent];
        var subQuestion = !!affectingAnswer;

        if (next && subQuestion) {
          affectingFlow[next.ident] = '-1'; // if next has subquestion

          if (affectingFilter.operation === 'in' &&
              affectingFilter.values.includes(affectingAnswer)) {
            // ok
          } else
          if (affectingFilter.operation === 'ne' &&
              !affectingFilter.value &&
              affectingAnswer !== '-1') {
            // ok
          }
          else {
            repeat = true;
          }
        }
      } while (repeat);

      $nextQuestion = $possibleNextQuestion;

      // Hide next icon if needed
      if ($nextQuestion.is('[data-answered="0"]')) {
        $('.js-next').addClass('control--hidden');
      }

      // Show prev icon
      setTimeout(function() {
        $('.js-prev').removeClass('control--hidden');
      }, delay);

    // If previous
    } else if (direction === 'prev') {

      // Set new DOM element
      $nextQuestion = $currentQuestion.next();

      // Show only answered questions
      while ($nextQuestion.attr('data-answered') !== '1') {
        $nextQuestion = $nextQuestion.next();
      }

      // Show next icon
      setTimeout(function() {
        $('.js-next').removeClass('control--hidden');
      }, delay);
    }

    // Get next question number
    var questionNumber = parseInt($nextQuestion.attr('data-number'), 10);

    var questionLength = $('.js-question').length;
    if (questionNumber === questionLength) { // If next question is last question
      $('.js-next').addClass('control--hidden');
    } else if (questionNumber === 1 || !questionNumber) { // If next question is first question OR start screen
      $('.js-prev').addClass('control--hidden');
    }

    if (params.isLive) {
      $('.control--close').toggleClass('control--hidden',
        questionNumber === questionLength || questionNumber === 1);
    }

    setTimeout(function() {

      // Hide current question
      $currentQuestion.attr('data-visibility', 'is-hidden');

      // Show new question
      $nextQuestion.attr('data-visibility', 'is-visible');

      // Slide in new question
      moveContainer(questionNumber === 0 ? 1 : questionNumber);

    }, delay);

  };

  ///////////////////////
  // BIND CLICK EVENTS //
  ///////////////////////

  $('.js-next').on('click', function() {
    switchQuestion('next', 0);
  });

  $('.js-prev').on('click', function() {
    switchQuestion('prev', 0);
  });

  $('.js-close').on('click', function() {
    if ($(this).hasClass('js-decline')) {
      trackMixpanel('Invitation declined');
    } else {
      trackMixpanel('Survey closed');
    }

    setTimeout(function () {
      if (window.parent !== window) {
        window.parent.postMessage({ name: 'close' }, '*'); // to be deprecated
        window.parent.postMessage({ name: 'userreport.surveyEnded' }, '*'); // used in VPAID and Embed Surveys
      } else {
        window.close();
      }
    }, 300);
  });

  $('.js-check').on('click', function(){
    $(this).closest('.checkbox-wrap').removeClass('error');
  }).focus();

  $('.js-item').on('click', function(event) {
    if ($(this).hasClass('js-close')) {
      return false;
    }

    if ($(this).hasClass('js-accept')) {
      var checkbox = $('.js-check');

      if (!checkbox.is(':checked')) {
        checkbox.focus().closest('.checkbox-wrap').addClass('error');
        trackMixpanel('Accept without privacy');
        if (checkbox[0].reportValidity) {
          checkbox[0].reportValidity();
        }

        return;
      } else {
        trackMixpanel('Invitation accepted');
      }
    }

    var answerNode = $(this).find('[data-number]');
    var answer = answerNode.attr('data-result') || answerNode.attr('data-number');

    $(this)
      .addClass('is-selected')
      .closest('.js-question')
      .attr('data-answered', '1')
      .attr('data-result', answer);

    trackAnswer(this);
    switchQuestion('next', 500);
  });

  $('.js-question[data-answered="0"] .input-wrap .button').on('click', function() {
      var $t = $(this);
      var $q = $t.closest('.js-question');
      var $iw = $t.closest('.input-wrap');
      var result = $iw.find('.input-text, .select select');

      if (result[0].checkValidity && !result[0].checkValidity()) {
        if (result[0].reportValidity) {
          result[0].reportValidity();
        }

        return;
      }

      $q.attr('data-answered', '1')
        .attr('data-result', result.val());

      $iw.hide();

      var $answerBox = $q.find('.answer-box');
      $answerBox.find('strong').html(result.find('option:selected').text() || result.val());
      $answerBox.removeClass('answer-box--hidden');

      trackAnswer(this);
      switchQuestion('next', 500);
  });

  ///////////////////
  // ACCESSIBILITY //
  ///////////////////

  var keyboardNavigation = true;

  $.fn.triggerClick = function(){
    this.each(function(){
      var t = $(this);
      t.trigger('click');
      t.addClass('simulated-active');
      setTimeout(function(){
        t.removeClass('simulated-active');
      }, 20);
    });
  };

  $(document).on('keydown', function (e) {
    // Arrow navigation
    if(e.which === KEY_UP) { $('.js-prev:not(.control--hidden)').triggerClick(); }
    if(e.which === KEY_DOWN) { $('.js-next:not(.control--hidden)').triggerClick(); }

    if (keyboardNavigation) {
      function triggerQuestionClick(itemClass) {
        var q = '.js-question[data-visibility="is-visible"][data-answered="0"]';

        $(q + ' ' + itemClass + ':not(.control--hidden)').triggerClick();
      }

      // Number navigation
      switch (e.which) {
        case KEY_0: triggerQuestionClick('.js-item-0'); break;
        case KEY_1: triggerQuestionClick('.js-item-1'); break;
        case KEY_2: triggerQuestionClick('.js-item-2'); break;
        case KEY_3: triggerQuestionClick('.js-item-3'); break;
        case KEY_4: triggerQuestionClick('.js-item-4'); break;
        case KEY_5: triggerQuestionClick('.js-item-5'); break;
        case KEY_6: triggerQuestionClick('.js-item-6'); break;
        default: break;
      }

      // Answer Enter
      if(e.which === KEY_ESC) { $('.js-close:not(.control--hidden)').triggerClick(); }
    }
  });

  // Swipe events
  if (Modernizr.touchevents) {
    $('.js-questions').swipe({
      swipeUp: function() { $('.js-prev:not(.control--hidden)').triggerClick(); },
      swipeDown: function() { $('.js-next:not(.control--hidden)').triggerClick(); },
      threshold:20
    });
  }

  //Scroll events
  var scrollPrevented = false;
  $(window).on('wheel', function(e) {
    if (scrollPrevented) {
      e.preventDefault();
      return false;
    }

    var delta = e.originalEvent.deltaY;

  	// Down
  	if (delta > 0) {
      $('.js-prev:not(.control--hidden)').triggerClick();
    // Up
  	} else {
    	$('.js-next:not(.control--hidden)').triggerClick();
    }

    scrollPrevented = true;
    setTimeout(function() {
      scrollPrevented = false;
    }, 1000);

  	return false;

  });

  // Input events
  $('.input-text').on('focus', function(){
    $('body').addClass('body--no-keyboard-nav');
    keyboardNavigation = false;
  });

  $('.input-text').on('blur', function(){
    $('body').removeClass('body--no-keyboard-nav');
    keyboardNavigation = true;
  });

  $('.input-text').on('keyup', function(e){

    var $t = $(this);
    var $iw = $t.closest('.input-wrap');

    if(e.which === KEY_ENTER) {
      if ($t[0].checkValidity && !$t[0].checkValidity()) {
        if ($t[0].reportValidity) {
          $t[0].reportValidity();
        }

        return;
      }
      var result = $(this).val();

      $t.blur().closest('.js-question')
        .attr('data-answered', '1')
        .attr('data-result', result);

      $t.closest('.js-question').find('strong').html(result);

      trackAnswer(this);

      $iw.hide();
      $t.closest('.js-question').find('.answer-box').removeClass('answer-box--hidden');
      switchQuestion('next', 500);
    }

    if (e.which === KEY_ESC) {
      $(this).blur();
    }

  });

  window.focus();

  // Show 'skip' button
  setTimeout(function() {
    $('.button-delay').removeClass('button-disabled');
  }, 5 * 1000);

  var LOAD_END_TIME = (new Date()).getTime();
  var loadTime = LOAD_END_TIME - LOAD_START_TIME;
  trackMixpanel('Invitation shown', { 'Load time (ms)': loadTime });
});
